export default "__VITE_ASSET__5w9uUePa__"